module.exports = __webpack_public_path__ + "static/img/b5_body.e00ae0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b5_body.png
// module id = oVXf
// module chunks = 1